import { render, staticRenderFns } from "./VaDetailsButton.vue?vue&type=template&id=05687847&"
import script from "./VaDetailsButton.vue?vue&type=script&lang=ts&"
export * from "./VaDetailsButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05687847')) {
      api.createRecord('05687847', component.options)
    } else {
      api.reload('05687847', component.options)
    }
    module.hot.accept("./VaDetailsButton.vue?vue&type=template&id=05687847&", function () {
      api.rerender('05687847', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/VaDetailsButton.vue"
export default component.exports